import{format as o}from"date-fns";const t=(t,r)=>o(t,r);export{t as formatDate};
//# sourceMappingURL=formatDate.js.map
